export default __webpack_public_path__ + "static/media/dia10.006ead23.png";